import { adminConfigurationSchema } from "@/components/Forms/schema/adminConfigurationSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createDataSelector, createResourceSelector } from "jsonapi-zod-query";

const resourceSelector = createResourceSelector({
    type: "adminConfiguration",
    attributesSchema: adminConfigurationSchema,
});

export const adminConfigurationSelector = createDataSelector(resourceSelector);
export type AdminConfiguration = ReturnType<typeof adminConfigurationSelector>;

export type AdminConfigurationDocument = ReturnType<typeof resourceSelector>;

export const useFetchAdminConfiguration = (): UseQueryResult<AdminConfigurationDocument> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["admin-configuration"],
        queryFn: async () => {
            const fetchURL = apiUrl("/admin/document-template");

            const response = await fetch(fetchURL.href, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: resourceSelector,
    });
};
